import { useEffect, useState } from 'react'

// SSR-safe: always false on the server and on the first client render, then
// reads the real media query after mount.
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(query)
        const update = () => setMatches(media.matches)

        update()
        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [query])

    return matches
}
